import React from "react";
import PropTypes from "prop-types";
import { Col, Form, Row } from "react-bootstrap";
import TimePicker from "react-bootstrap-time-picker";

const CustomHoursPicker = ({
  fromHourName,
  toHourName,
  fromHourValue,
  toHourValue,
  setFieldValue,
  errors,
  touched,
  submitCount,
  labelwidth = 12,
  inputwidth = 12,
}) => {
  // Convert HH:mm to seconds (for TimePicker)
  const timeToSeconds = (timeStr) => {
    if (!timeStr || timeStr === "") return null;
    const parts = timeStr.split(":");
    if (parts.length >= 2) {
      const hours = parseInt(parts[0], 10);
      const minutes = parseInt(parts[1], 10);
      if (isNaN(hours) || isNaN(minutes)) return null;
      return hours * 3600 + minutes * 60;
    }
    return null;
  };

  // Convert seconds to HH:mm format
  const secondsToTime = (seconds) => {
    if (seconds === null || seconds === undefined) return "";
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
  };

  const handleFromHourChange = (seconds) => {
    const timeStr = secondsToTime(seconds);
    setFieldValue(fromHourName, timeStr);
  };

  const handleToHourChange = (seconds) => {
    const timeStr = secondsToTime(seconds);
    setFieldValue(toHourName, timeStr);
  };

  const fromHourError = errors && errors[fromHourName];
  const toHourError = errors && errors[toHourName];
  const fromHourTouched = touched && touched[fromHourName];
  const toHourTouched = touched && touched[toHourName];
  const showFromError = fromHourError && (fromHourTouched || !!submitCount);
  const showToError = toHourError && (toHourTouched || !!submitCount);

  return (
    <Form.Group as={Row} controlId="customHoursPicker" className="mb-0">
      <Col sm={inputwidth}>
        <div className="d-flex align-items-center gap-3">
          <div className="flex-fill">
            <Form.Label htmlFor={`${fromHourName}-timepicker`} className="form-label d-block">
              Start Hour
            </Form.Label>
            <div className={showFromError ? "is-invalid" : ""} id={`${fromHourName}-timepicker`}>
              <TimePicker
                start="00:00"
                end="23:59"
                step={30}
                value={timeToSeconds(fromHourValue) || 0}
                onChange={handleFromHourChange}
                format={12}
              />
            </div>
            {showFromError && (
              <div className="invalid-feedback d-block">{fromHourError}</div>
            )}
          </div>
          <div className="flex-fill">
            <Form.Label htmlFor={`${toHourName}-timepicker`} className="form-label mb-2 d-block">
              End Hour
            </Form.Label>
            <div className={showToError ? "is-invalid" : ""} id={`${toHourName}-timepicker`}>
              <TimePicker
                start="00:00"
                end="23:59"
                step={30}
                value={timeToSeconds(toHourValue) || 0}
                onChange={handleToHourChange}
                format={12}
              />
            </div>
            {showToError && (
              <div className="invalid-feedback d-block">{toHourError}</div>
            )}
          </div>
        </div>
        {/* <small className="mt-2 d-block">
          Optional: Leave empty to include all hours.
        </small> */}
      </Col>
    </Form.Group>
  );
};

CustomHoursPicker.propTypes = {
  label: PropTypes.string,
  fromHourName: PropTypes.string.isRequired,
  toHourName: PropTypes.string.isRequired,
  fromHourValue: PropTypes.string,
  toHourValue: PropTypes.string,
  setFieldValue: PropTypes.func.isRequired,
  errors: PropTypes.object,
  touched: PropTypes.object,
  submitCount: PropTypes.number,
  labelwidth: PropTypes.number,
  inputwidth: PropTypes.number,
};

export default CustomHoursPicker;

